import type { StateNodeConfig, StateSchema } from 'xstate'

import type {
  MachineContext,
  MachineEvents,
} from '~/scopes/customer-care/resolution/machine/ResolutionFlow.machine.types'

import { ExpressReplacementState } from './ExpressReplacement.state'
import { ExpressReplacementTransitions } from './ExpressReplacement.transitions'

export const ExpressReplacementSchema: StateNodeConfig<
  MachineContext,
  StateSchema<MachineContext>,
  MachineEvents
> = {
  on: ExpressReplacementTransitions,
  states: ExpressReplacementState,
}
